import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const LocationDistance = ({ label, accountId }) => {
	const labels = useLabels();

	const buttonProps = {
		'data-href': `/fragments/location-distance.htm?selectedAccountId=${accountId}`,
		'data-title': labels.get('VEHICLE_LOCATION'),
		'data-width': '800',
		'data-dialog-class': 'sms-form-dialog',
		'data-cache': false
	};

	// Label comes in formatted as 'accountName ::: geoDist' from the `locationDistance` item in the `attributes` array
	// This splits it and applies an underline only on the geoDist if present
	const [accountName, geoDist] = label.split(':::');

	const displayAccountNameOnly = geoDist === undefined || geoDist === '';

	return (
		<button
			{...buttonProps}
			type="button"
			className="btn-unstyled text-muted dialog"
		>
			<i
				className="ddc-icon ddc-icon-map align-middle pr-2"
				aria-hidden="true"
			/>
			{displayAccountNameOnly ? null : accountName}
			<span className="text-decoration-underline">
				{displayAccountNameOnly ? accountName : geoDist}
			</span>
		</button>
	);
};

LocationDistance.propTypes = {
	label: PropTypes.string.isRequired,
	accountId: PropTypes.string.isRequired
};

export default LocationDistance;
